import _ from 'lodash'

import { Order } from '../types'

export function getDeliveryName(order: Order): string {
  const { firstName, lastName } = order.delivery.contact.name

  return lastName + firstName
}

export function getAddress1(order: Order): string {
  const { region, locality } = order.delivery.contact.address

  return region + locality
}

export function getAddress2(order: Order): string {
  return order.delivery.contact.address.street
}

// TODO: Integrate 'subtotal' and 'subTotal' in all other places
export function getSubTotalPrice(order: Order): number {
  return _.get(order.chargeSheet.order, 'priceIncludingTax.price', 0)
}

export function hasFatalError(order: Order): boolean {
  return order.salesOrderStatus === 'payment-fatal-error'
}

/**
 * 注文に含まれる商品が全てカタログ商品かどうか.
 *
 * なお、注文後に商品が非公開化しROOTを取得できない商品は isCatalogType が
 * 初期値の false のままとなる（@see services/orderHistory.ts injectWithJoinedProductInfo）。
 * したがって、商品非公開化によってtrueを返すようになることはない。
 */
export function isAllCatalogProducts(order: Order): boolean {
  return order.products.length !== 0 && order.products.every(product => product.isCatalogType)
}
